<div class="sidebar" [ngClass]="{ 'sidebar-collapsed': isCollapsed, 'sidebar-expanded': !isCollapsed }">

  <div class="sidebar-header">
    <button class="collapse-btn" (click)="toggleSidebar()"
      [attr.aria-label]="isCollapsed ? ('showNavigation' | translate) : ('hideNavigation' | translate)">
      <svg *ngIf="!isCollapsed" class="collapse-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M15 4L9 10L15 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M9 4L3 10L9 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <svg *ngIf="isCollapsed" class="collapse-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M5 4L11 10L5 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M11 4L17 10L11 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <nav class="sidebar-nav" role="navigation">
    <ng-container *ngFor="let section of sections; let sectionIndex = index; trackBy: trackBySection">
      <div class="nav-section" *ngIf="section.children && section.children.length > 0">
        <div class="section-title" *ngIf="section.title && !isCollapsed">
          {{ section.title | translate }}
        </div>
        <div class="section-divider" *ngIf="section.title && isCollapsed"></div>

        <ul class="nav-list">
          <li *ngFor="let item of section.children; trackBy: trackByNavItem" class="nav-item">
            <ng-container *ngIf="!item.children || item.children.length === 0">
              <a class="nav-link" [class.disabled]="item.disabled" [routerLink]="item.disabled || item.externalUrl ? null : item.path"
                [queryParams]="item.queryParams" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }"
                (click)="handleNavClick($event, item)" [title]="isCollapsed ? (item.title | translate) : ''">
                <span class="nav-icon" [innerHTML]="getNavIcon(item)"></span>
                <span class="nav-text" *ngIf="!isCollapsed">{{ item.title | translate }}</span>
                <span class="badge-new" *ngIf="item.isNew && !isCollapsed">{{ 'newBadge' | translate }}</span>
              </a>
            </ng-container>

            <ng-container *ngIf="item.children && item.children.length > 0">
              <div class="nav-link-wrapper has-children" [class.disabled]="item.disabled"
                [ngClass]="{ 'expanded': isExpanded(item.title), 'active': isChildActive(item) || checkSamePath(item.path) }">
                <a class="nav-link-content" [routerLink]="item.disabled || !item.path ? null : item.path"
                  [queryParams]="item.queryParams" (click)="onParentNavClick($event, item)"
                  [title]="isCollapsed ? (item.title | translate) : ''">
                  <span class="nav-icon" [innerHTML]="getNavIcon(item)"></span>
                  <span class="nav-text" *ngIf="!isCollapsed">{{ item.title | translate }}</span>
                </a>
                <button *ngIf="!isCollapsed" class="nav-chevron-btn"
                  (click)="toggleExpand(item.title); $event.stopPropagation()">
                  <svg class="nav-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>

              <ul class="submenu level-1" *ngIf="!isCollapsed"
                [ngClass]="{ 'show': isExpanded(item.title), 'has-active': isChildActive(item) }">
                <li *ngFor="let child of item.children; trackBy: trackBySubmenuItem" class="submenu-item">
                  <ng-container *ngIf="!child.children || child.children.length === 0">
                    <a class="submenu-link" [class.disabled]="child.disabled"
                      [routerLink]="child.disabled ? null : child.path" [queryParams]="child.queryParams"
                      [class.active]="isLinkActive(child)" (click)="handleNavClick($event, child)">
                      <span class="submenu-icon" *ngIf="child.icon" [innerHTML]="getNavIcon(child)"></span>
                      <span class="submenu-text">{{ child.title | translate }}</span>
                    </a>
                  </ng-container>

                  <ng-container *ngIf="child.children && child.children.length > 0">
                    <div class="submenu-link-wrapper has-children" [class.disabled]="child.disabled"
                      [ngClass]="{ 'expanded': isExpanded(child.title), 'active': isChildActive(child) || checkSamePath(child.path) }">
                      <a class="submenu-link-content" [routerLink]="child.disabled || !child.path ? null : child.path"
                        [queryParams]="child.queryParams" (click)="onParentNavClick($event, child)">
                        <span class="submenu-icon" *ngIf="child.icon" [innerHTML]="getNavIcon(child)"></span>
                        <span class="submenu-text">{{ child.title | translate }}</span>
                      </a>
                      <button class="submenu-chevron-btn" (click)="toggleExpand(child.title); $event.stopPropagation()">
                        <svg class="submenu-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </button>
                    </div>

                    <ul class="submenu level-2"
                      [ngClass]="{ 'show': isExpanded(child.title), 'has-active': isChildActive(child) }">
                      <li *ngFor="let grandchild of child.children; trackBy: trackBySubmenuItem" class="submenu-item">
                        <a class="submenu-link level-3" [class.disabled]="grandchild.disabled"
                          [routerLink]="grandchild.disabled ? null : grandchild.path"
                          [queryParams]="grandchild.queryParams" [class.active]="isLinkActive(grandchild)"
                          (click)="handleNavClick($event, grandchild)">
                          <span class="submenu-icon" *ngIf="grandchild.icon"
                            [innerHTML]="getNavIcon(grandchild)"></span>
                          <span class="submenu-text">{{ grandchild.title | translate }}</span>
                        </a>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </ng-container>
          </li>
        </ul>
      </div>
    </ng-container>
  </nav>
</div>